export const ROUTES = {
  DASHBOARD: '/',
  LOGIN: '/login',
  PATIENTS: '/patients',
  PATIENT_CREATE: '/patients/new',
  PATIENT_DETAIL: '/patients/:id',
  // PATIENT_VITALS: '/patients/:id/generate', (removed - generation moved into PatientDetail)
  SCHEDULES: '/schedules',
  SCHEDULE_DETAIL: '/schedules/:id',
  JOBS: '/jobs',
  SETTINGS: '/settings',
}

// Helper functions for dynamic routes
export const getPatientDetailRoute = (id: number | string) => `/patients/${id}`
// export const getPatientVitalsRoute = (id: number | string) => `/patients/${id}/generate`
export const getScheduleRoute = (id: number | string) => `/schedules/${id}`
